import React from "react"
import { motion } from 'framer-motion'
import { useDispatch } from "react-redux"
import { setLoggedIn, setUserDetails } from "../Store/Auth/actions";
import { useHistory } from "react-router-dom";
import { FaPowerOff } from "react-icons/fa6";
import LanguageSwitcher from "./LanguageSwitcher";
import { setLanguage } from "../Store/Theme/actions";

const TopBar = () => {

    const dispatch = useDispatch()
    const history = useHistory()

    const logout = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('accountType')
        window.location.reload()
        dispatch(setUserDetails({}))
        dispatch(setLoggedIn(false))
        history.push('/')
    }

    return (
        <>
            <motion.div className="flex z-50 flex-row justify-end flex items-center py-10 px-10 md:py-2 relative rounded-xl w-full">
        <LanguageSwitcher onToggle={(lang) => dispatch(setLanguage(lang))} />
                <FaPowerOff className="mx-5 text-2xl font-bold cursor-pointer" onClick={() => logout()} />
            </motion.div>
        </>
    )
}

export default TopBar